<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations de l'étudiant</h4>
            <router-link to="/liste-inscriptions" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              Retour
            </router-link>
          </div>

          <table class="table">
            <tbody>
              <tr v-if="inscription?.etudiant?.numeroMatricule">
                <td>Numéro Matricule :</td>
                <td>{{ inscription?.etudiant?.numeroMatricule }}</td>
              </tr>
              <tr v-if="inscription?.etudiant?.nom">
                <td>Nom :</td>
                <td>{{ inscription?.etudiant?.nom }}</td>
              </tr>
              <tr v-if="inscription?.etudiant?.prenom">
                <td>Prénom :</td>
                <td>{{ inscription?.etudiant?.prenom }}</td>
              </tr>
              <tr v-if="inscription?.etudiant?.email">
                <td>Email :</td>
                <td>{{ inscription?.etudiant?.email }}</td>
              </tr>
              <tr v-if="inscription?.filiere?.libelle">
                <td>Filière :</td>
                <td>{{ inscription?.filiere?.libelle }}</td>
              </tr>
              <tr v-if="inscription?.niveau?.libelle">
                <td>Niveau :</td>
                <td>{{ inscription?.niveau?.libelle }}</td>
              </tr>
              <tr v-if="inscription?.annee?.libelle">
                <td>Année Académique :</td>
                <td>{{ inscription?.annee?.libelle }}</td>
              </tr>
              <tr v-if="inscription?.etudiant?.parentetudiants?.length">
                <td>Parent/Tuteur :</td>
                <td>
                  {{ inscription.etudiant.parentetudiants[0].parent.nom }}
                  {{ inscription.etudiant.parentetudiants[0].parent.prenom }}
                </td>
              </tr>


            </tbody>
          </table>

          <div class="col-md-12" v-if="inscription?.etudiant?.pieces?.length">
            <div style="max-width: 1200px; width: 100%; margin: auto;">
              <h5 class="mt-3 text-center">Pièces jointes</h5>
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Numéro</th>
                    <th>Document</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(piece, index) in inscription.etudiant.pieces" :key="index">
                    <td>{{ piece.typePiece?.libelle }}</td>
                    <td>{{ piece.numeroPiece }}</td>
                    
                    
                    <td>
                      <a :href="getUrlApiForInscriptionsFiles(piece.urlImage)" target="_blank" class="btn btn-sm btn-outline-primary">
                        Voir
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import { useRoute } from "vue-router";
import { error,getUrlApiForInscriptionsFiles } from "@/utils/utils";

export default defineComponent({
  name: "ViewInscription",
  setup() {
    const route = useRoute();
    const inscription = ref<any>(null);

    const typesPieces = ref<any[]>([]);

   
    const getInscription = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/inscriptions/${id}`);
        inscription.value = data.data;
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement de l'inscription");
      }
    };

    onMounted(() => {
      const id = route.params.id as string;
      Promise.all([getInscription(id)]);
    });

    return {
      inscription,getUrlApiForInscriptionsFiles,
      typesPieces // Optionnel, si tu veux l'utiliser ailleurs
    };
  }
});
</script>
